var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c("h5", { staticClass: "mr-3" }, [_vm._v("¿Qué son los pasos?")]),
          _c(
            "vs-button",
            {
              staticClass: "p-3",
              attrs: { "icon-after": "", icon: "info" },
              on: {
                click: function($event) {
                  return _vm.$refs.stepsInfo.show()
                }
              }
            },
            [_vm._v(" Explicación ")]
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          ref: "stepsInfo",
          attrs: {
            title: "Pasos",
            size: "lg",
            centered: "",
            "no-close-on-backdrop": "",
            "hide-footer": ""
          }
        },
        [
          _c("p", [
            _vm._v(
              " Los pasos son los participantes del proceso de aprobación. Para estos participantes se pueden definir 3 roles: "
            )
          ]),
          _c("p", [
            _c("ul", [
              _c("li", [
                _c("b", [_vm._v("1. Revisor: ")]),
                _vm._v(
                  "Es un rol especial, que sólo permite a alguien emitir una opinión. Aún cuando su opinión sea rechazar, el proceso seguirá avanzando. "
                )
              ]),
              _c("br"),
              _c("li", [
                _c("b", [_vm._v("2. Aprobador:")]),
                _vm._v(
                  " Es un rol que permite aprobar o rechazar el proceso. A diferencia del revisor, cuando un Aprobador rechaza, el proceso de aprobación finaliza. "
                )
              ]),
              _c("br"),
              _c("li", [
                _c("b", [_vm._v("3. Firmante: ")]),
                _vm._v(
                  " El Rol firmante es para aquellos aprobadores que deben incorporar Firma Electrónica a los documentos que son parte del proceso de aprobación. Al igual que el aprobador, si un Firmante rechaza el documento, esto terminará el proceso. "
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }